import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCommentDialog } from 'store/dialog/reducer';
import { generateRandomId } from 'utility/general';

const useCommentDialog = () => {
    const result = useSelector((state) => state.dialog.commentDialog.result);
    const isShow = useSelector((state) => state.dialog.commentDialog.isShow);
    const comment = useSelector((state) => state.dialog.commentDialog.comment);
    const fileIds = useSelector((state) => state.dialog.commentDialog.fileIds);
    const cluster = useSelector((state) => state.dialog.commentDialog.cluster);
    const expiryDate = useSelector((state) => state.dialog.commentDialog.expiryDate);
    const dispatch = useDispatch();
    const resolver = useRef();
    const isShowLocal = useRef(false);

    useEffect(() => {
        if (result !== undefined && isShow === false) {
            if (isShowLocal.current === false) {
                return;
            }

            isShowLocal.current = false;
            resolver.current && resolver.current({ submit: result, comment: comment, fileIds, expiryDate, cluster });

            dispatch(
                updateCommentDialog({
                    isShow: false,
                    result: undefined,
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comment, isShow, result, fileIds, expiryDate, cluster]);

    const handleShow = ({
        title,
        description,
        placeholder,
        showUploadButton = false,
        cancelButtonText,
        confirmButtonText,
        isRequired = true,
        showExpiryDate = false,
        showClusterSelect = false,
    }) => {
        isShowLocal.current = true;
        dispatch(
            updateCommentDialog({
                isShow: true,
                title,
                description,
                placeholder,
                showUploadButton,
                cancelButtonText,
                confirmButtonText,
                showClusterSelect,
                fileIds: [],
                uploadKey: generateRandomId(),
                isRequired,
                showExpiryDate,
                expiryDate,
            }),
        );

        return new Promise(function (resolve) {
            resolver.current = resolve;
        });
    };

    return handleShow;
};

export default useCommentDialog;
